<template>
  <div class="card" :class="!show_content ? 'card_pb10' : ''">
    <div class="header" @click="show_this_block()">
      <div class="title">
        {{ translate("device.simcard_status")}}
        <span>
          ( {{ show_content ? translate('click_to_hide') : translate('click_to_show') }} )
        </span>
      </div>

    </div>
    <div class="content" :class="{ show_content: show_content }" v-on:wheel="wheel" v-if="show_content">
      <div style="text-align: center;  vertical-align: middle;">
        <!-- <span><span class="time_legend">NONE: </span> <span class="NONE block-legend" /></span> -->
        <span><span class="time_legend">NA: </span> <span class="NA block-legend" /></span>
        <span><span class="time_legend">2G: </span> <span class="_2G block-legend" /></span>
        <span><span class="time_legend">3G: </span> <span class="_3G block-legend" /></span>
        <span><span class="time_legend">4G: </span> <span class="_4G block-legend" /></span>
        <!-- <br>
        <span><span class="time_legend">OFFLINE: </span> <span class="OFFLINE block-legend" /></span>
        <span><span class="time_legend">ONLINE: </span> <span class="ONLINE block-legend" /></span> -->
      </div>
      <div class="echarts_timeline">
        <div class="spinner_charts" v-if="load">
          <scale-loader style="position: relative; padding-top: 10%" />
        </div>
        <IEcharts
          v-if='show_content'
          :option="option"
          @ready="onReady"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { encodeHTML } from 'echarts/lib/util/format'

export default {
  name: 'TimelineChart',
  props: ['main_data', 'dev_fid', 'show_content', 'today'],

  data () {
    // const that = this
    return {
      ins: null,
      echarts: null,
      show: false,
      data2: [],
      show2: false,
      load: true
    }
  },
  computed: {
    info(){
      return this.main_data
    },
    option () {
      return {
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {
              title: this.translate('save'),
              type: 'png',
              pixelRatio: 5

            }
          }
        },
        tooltip: {
          formatter: (params) => {
            let date = new Date()
            if (params.value === undefined) {
              return ''
            }
            date.setTime(params.value[1])
            let date2 = new Date()
            date2.setTime(params.value[2])
            let options = {hour: '2-digit', minute: '2-digit', hour12: false}
            let date_str = '(' + date.toLocaleString(navigator.language, options) + '-' + date2.toLocaleString(navigator.language, options) + ')'

            if (this.info.category[params.value[0]] === 'event_timeline') {
              const event = params.data
              return params.marker + encodeHTML(`${event.event_type ?? ''}:${event.name ?? ''}`) + ' ' + date_str
                  + '<br/>' + encodeHTML(String(event.description ?? '')).replace(/\r?\n/g, '<br/>')
            }

            let string = params.marker + this.info.category[params.value[0]]
            if (["Online", "Monitoring", "Stcp"].includes(this.info.category[params.value[0]])){
              string = string + " " + date_str + '<br/>'
            }else{
              string = string + ': ' + params.data.mode + '  ' + params.data.rssi + "dBm " + date_str + '<br/>'
            }
            return string
          }
        },
        dataZoom: [{
          type: 'slider',
          filterMode: 'weakFilter',
          showDataShadow: false,
          height: 20,
          realtime: false,
          borderColor: 'transparent',
          backgroundColor: '#e2e2e2',
          handleSize: 25,

          preventDefaultMouseMove: false,
          handleStyle: {
            shadowBlur: 6,
            shadowOffsetX: 1,
            shadowOffsetY: 2,
            shadowColor: '#aaa'
          }
        }],
        grid: {
          height: '55%',
          left: 90,
          right: 35
        },
        xAxis: {
          scale: true,
          type: 'time',
          axisLabel: {
            formatter: this.translate_of_time
          }
        },
        yAxis: {
          axisPointer: {
            show: true,
            type: 'shadow'
          },
          data: this.set_category()
        },
        series: [{
          animation: true,
          animationEasing: 'linear',
          animationEasingUpdate: 'linear',
          type: 'custom',
          renderItem: this.renderItem,
          itemStyle: {
            opacity: 0.8
          },
          encode: {
            x: [1, 2],
            y: 0
          },
          data: this.data2
        }]
      }
    }
  },

  watch: {
    info () {
      if (this.info.data && Object.keys(this.info.data).length !== 0) {
        this.load = false
        this.data2 = this.info.data.map((item) => {
          return {...item}
        })
        // console.log(this.data2)
      } else {
        this.load = true
      }
    }
  },
  methods: {
    show_this_block(){
      this.$emit('show_simcard_status')
    },
    translate_of_time(unixTime){
      let options = {}
      if (this.today) {
        options = {
          hour12: false,
          hour: '2-digit',
          minute: '2-digit'
        }
      }else{
        options = {
          hour12: false,
          hour: '2-digit',
          minute: '2-digit',
          day: '2-digit',
          month: '2-digit'
        }
      }
      return this.get_date(unixTime/1000, options)
    },
    wheel (event) {
      if (event.shiftKey) {

        let start = this.ins.getOption().dataZoom[0].start + event.zrDelta * 2
        let end = this.ins.getOption().dataZoom[0].end - event.zrDelta * 2
        if(start < 0 || end > 100 || start > end || end < start || (end - start <= 0) ) {
          return false
        }
        this.ins.dispatchAction({
          type: 'dataZoom',
          start: start,
          end: end,
        })
      }
    },
    set_category () {
      let cat = []
      let category = ''
      let size = 0

      //this.info.category.sort().reverse()

      for (let i in this.info.category) {
        category = this.info.category[i]
        // calc font size for legend at chart
        if (category.length > 14) {
          //imsi
          category = category.substr(0, 10) + '...'
          size = 12
        } else {
          let max = 23
          size = max - category.length
        }
        cat.push({
          value: category,
          align: 'left',
          textStyle: {
            fontSize: size
          }
        })
      }
      return cat
    },
    onReady (instance, echarts) {
      const that = this
      that.ins = instance
      that.echarts = echarts
      this.load = true;
      this.data2 = this.info.data
      that.ins.on('finished',() => {
        setTimeout(() => this.load = false, 100)
      })
      const updatePosition = function () {
        if (that.ins.resize !== undefined || that.ins.resize !== null) {
          that.ins.resize()
        }
      }
      window.addEventListener('resize', updatePosition)
      updatePosition()
    },

    renderItem (params, api) {
      var categoryIndex = api.value(0)
      var start = api.coord([api.value(1), categoryIndex])
      var end = api.coord([api.value(2), categoryIndex])
      var height = api.size([0, 1])[1] * 0.6

      return {
        type: 'rect',
        shape: this.echarts.graphic.clipRectByRect({
          x: start[0],
          y: start[1] - height / 2,
          width: (end[0] - start[0]),
          height: height
        }, {
          x: params.coordSys.x,
          y: params.coordSys.y,
          width: params.coordSys.width,
          height: params.coordSys.height
        }),
        style: api.style()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .card{
    padding: 10px 10px 0;
    &.card_pb10{
      padding-bottom: 10px;
    }
    .header{
      position: relative;
      cursor: pointer;
      padding: 10px 0;
      z-index: 2;
      .title{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        span{
          color: #999;
          font-size: 14px;
          font-weight: 600;
          margin-left: 5px;
        }
      }
    }
    .content{
      padding: 0 0 10px;
    }
  }
  .echarts_timeline {
    width: 100%;
    height: 290px;
    margin: -65px auto 0;
  }

  a {
    color: #42b983;
  }

  .block-legend {
    width: 40px;
    height: 20px;
    padding: 0;
    border-radius: 5px;
    display: inline-block;
  }

  .time_legend {
    vertical-align: super;
    margin-left: 5px;
  }

  .NA {
    background-color: #FF0000;
  }

  ._2G {
    background-color: #FFA500;
  }

  ._3G {
    background-color: #FFFF00;
  }

  ._4G {
    background-color: #008000;
  }

  .NONE {
    background-color: #858585;
  }

  .ONLINE {
    background-color: #00A000;
  }

  .OFFLINE {
    background-color: #A5A5A5;
  }
</style>
